import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="8" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 14.284l1.203 1.297L8 8.257 1.203.933 0 2.23l5.594 6.027L0 14.284z" fill="#313234" /></svg>);